import { createContext } from 'react'

/**
 * Context that provides a getter to get the last pointer position.
 */
export interface PointerPositionContext {
  /** Get the last known pointer position in client coordinates */
  readonly getLastPointerPosition: () => {
    readonly clientX: number
    readonly clientY: number
  } | null
}

export const PointerPositionContext = createContext<PointerPositionContext>({
  getLastPointerPosition: () => null,
})
